const homeComponant = {
  text: '[FR] - page d\'acceuil',
  componant: {
    name: 'home',
  },
};

export default {
  navbar: {
    menus: [
      {
        name: 'Producteurs',
        code: 'PROVIDERS',
      },
      {
        name: 'Produits',
        code: 'PRODUCTS',
        subMenuGroups: [
          // {
          //   title: 'Agence',
          //   items: [
          //     {
          //       name: 'Vins',
          //       code: 'VIN',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'IP',
          //         },
          //         {
          //           key: 'inventory',
          //           value: 'SAQ',
          //         },
          //       ],
          //     },
          //     {
          //       name: 'Cidres',
          //       code: 'CIDRE',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'IP',
          //         },
          //         {
          //           key: 'inventory',
          //           value: 'SAQ',
          //         },
          //       ],
          //     },
          //     {
          //       name: 'Bières',
          //       code: 'BIERE',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'IP',
          //         },
          //         {
          //           key: 'inventory',
          //           value: 'SAQ',
          //         },
          //       ],
          //     },
          //     {
          //       name: 'Spiritueux',
          //       code: 'SPIRITUEUX',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'IP',
          //         },
          //         {
          //           key: 'inventory',
          //           value: 'SAQ',
          //         },
          //       ],
          //     },
          //     {
          //       name: 'Apéritifs',
          //       code: 'APERITIF',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'IP',
          //         },
          //         {
          //           key: 'inventory',
          //           value: 'SAQ',
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   title: 'Boutique',
          //   items: [
          //     {
          //       name: 'Alcoolisé',
          //       code: 'TODO',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'STORE_MTL',
          //         },
          //       ],
          //     },
          //     {
          //       name: 'Nourriture',
          //       code: 'TODO',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'STORE_MTL',
          //         },
          //       ],
          //     },
          //     {
          //       name: 'Marchandises',
          //       code: 'TODO',
          //       inventories: [
          //         {
          //           key: 'inventory',
          //           value: 'STORE_MTL',
          //         },
          //       ],
          //     },
          //   ],
          // },
        ],
      },
      {
        name: 'Boutique',
        code: 'BOUTIQUE',
        subMenuGroups: [
          {
            title: 'Boutique',
            items: [
              {
                name: 'Montréal',
                code: 'MONTREAL',
                inventories: [
                  {
                    key: 'inventory',
                    value: 'STORE_MTL',
                  },
                ],
              },
              // {
              //   name: 'Québec',
              //   code: 'QUEBEC',
              //   inventories: [
              //     {
              //       key: 'inventory',
              //       value: 'STORE_QC',
              //     },
              //   ],
              // },
              {
                name: 'Toronto',
                code: '',
                inventories: [
                  {
                    key: 'inventory',
                    value: 'STORE_TORONTO',
                  },
                ],
              },
            ],
          }
        ]
      },
      {
        name: 'Clients',
        code: 'CLIENTS',
        // subMenuGroups: [
        //   {
        //     title: 'Clients',
        //     items: [
        //       {
        //         type: 'single',
        //         name: 'Membres',
        //         path: 'membres'
        //       },
        //       // {
        //       //   type: 'single',
        //       //   name: 'Découverte',
        //       //   path: ''
        //       // },
        //     ],
        //   },
        // ]
      },
      {
        name: 'Blogue',
        code: 'BLOG',
      },
    ],
    actionBar: {
      language: {
        label: 'Language',
        subMenuGroups: [
          {
            title: 'Language',
            items: [
              {
                code: 'EN',
                displayCode: 'EN',
                displayLabel: 'English',
                // Make sure `requestValue` map values in @/plugins/vue-i18n
                requestValue: 'en-US',
              },
              {
                code: 'FR',
                displayCode: 'FR',
                displayLabel: 'Français',
                // Make sure `requestValue` map values in @/plugins/vue-i18n
                requestValue: 'fr-CA',
              },
            ],
          },
        ],
      },
      country: {
        label: 'Province',
        subMenuGroups: [
          {
            title: 'Province',
            items: [
              {
                code: 'ON',
                displayCode: 'ON',
                displayLabel: 'Ontario',
              },
              {
                code: 'QC',
                displayCode: 'QC',
                displayLabel: 'Québec',
              },
            ],
          },
        ],
      },
      tax: {
        label: 'Tax',
        subMenuGroups: [
          {
            title: 'Taxes',
            items: [
              {
                code: 'IN',
                displayCode: 'Tax in',
                displayLabel: 'Incluses',
              },
              {
                code: 'OUT',
                displayCode: 'Tax ex',
                displayLabel: 'Excluses',
              },
            ],
          },
        ],
      },
    },
    previousBtnName: 'Menu',
    searchInput: {
      placeholder: 'Vin, année, producteur, article, etc.',
    },
  },
  filterBar: {
    label: {
      filter: 'Filtrer',
      reset: 'Réinitialiser',
      sort: 'Trier par',
      print: 'Imprimer',
      VueList: 'Vue liste',
      VueTuiles: 'Vue tuiles'
    },
    sortOptions: [
      {
        value: '',
        label: 'Réinitialiser',
      },
      {
        value: 'sortByPrice=DESC',
        label: 'Prix',
      },
      {
        value: 'sortByQty=DESC',
        label: 'Quantitée',
      },
    ],
    sortBlogOptions: [
      {
        value: 'sortByDate=ASC',
        label: 'Du plus ancien au plus récent',
      },
      {
        value: 'sortByDate=DESC',
        label: 'Du plus récent au plus ancien ',
      },
    ],
    placeHolder: 'Trier par'
  },
  previousPageBtn: {
    agency: 'Produits agence',
    boutique: 'Boutique',
    providers: 'Producteurs',
    blog: 'Blogues',
    myAccount: 'Mon compte',
    label: 'Retour',
    FrequentlyAskedQuestions: 'Foire aux questions',
    producer: 'Producteur',
    montrealShop: 'Boutique Montréal',
    quebecShop: 'Boutique Québec',
    torontoShop: 'Boutique Toronto',
  },
  pagination: {
    label: 'Page {currentPage} de {totalNumberOfPage}',
  },
  noRecordsFound: 'Aucun résultats trouvés',
  footer: {
    menus: {
      menuAbout: {
        header: 'À propos',
        company: 'Compagnie',
        restaurants: 'Boutique',
        faq: 'FAQ',
        privacy: 'Politique de Confidentialité',
      },
      menuAgency: {
        header: 'Produits',
        wines: 'Vins',
        ciders: 'Cidres',
        beers: 'Bières',
        alcools: 'Alcools',
        aperitifs: 'Apéritifs',
        agence: 'Agence',
        boutiqueMontreal: 'Boutique Montréal',
        boutiqueQuebec: 'Boutique Québec',
        boutiqueToronto: 'Boutique Toronto',
        order: 'Order',
      },
      menuStore: {
        header: 'Sans alcool',
        wines: 'Vins',
        foods: 'Nourritures',
        goods: 'Marchandises',
        boisson: 'Boisson',
        epicerie: 'Épicerie',
        marchandise: 'Marchandise'
      },
      menuDiscovery: {
        header: 'Découvrir',
        producers: 'Producteurs',
        suscriptions: 'Abonnements',
        blogs: 'Blogues',
        becomeAMember: 'Devenir client',
        mixedCase: 'Caisse mixte',
        contact: 'Contactez nous',
        boutique: 'Shop',
        member: 'Membre',
      },
      menuProducts: {
        header: 'Produits',
        wines: 'SAQ',
        BeersAndCiders: 'Import Privé',
        nonAlcoholic: 'LCBO',
        oliveOil: 'Olive oil',
        food: 'Nourriture',
        shops: 'Privé',
        divers: 'Divers'
      },
      menuProductsNew: {
        wines: 'Vin',
        spirits: 'Spiritueux',
        alcoholFree: 'Sans Alcool',
        otherProducts: 'Autre produits', 
      },
      menuRestaurant: {
        header: 'Boutique',
        menu: 'Menu',
        montreal: 'Montréal',
        toronto: 'Toronto',
      },
    },
    address: {
      montreal: {
        line1: '6422 Saint-Laurent',
        line2: '',
        line3: 'Montréal, QC, H2S 3C4',
      },
      toronto: {
        line1: '1583 Dupont',
        line2: 'Toronto, ON, M6P 3S5',
      },
    },
    allRightsReserved: 'Boires inc. tous droits réservés - BOIRES est une marque de commerce déposée de Boires Inc.',
    socialLink: {
      youtube: 'https://www.youtube.com/channel/UCIEjAJMsHkVba-H1rOdBqIg',
      instagram: 'https://www.instagram.com/boires.ca/',
      facebook: 'https://www.facebook.com/boires.ca/',
    }
  },
  notFound: {
    title: 'Oups, nous n\'avons pas pu trouver cette page',
    type: {
      unknown: {
        links: [
          homeComponant,
        ],
      },
      blogs: {
        links: [
          homeComponant,
          {
            text: '[FR] - page des blogs',
            componant: {
              name: 'blogs',
            },
          },
        ],
      },
      products: {
        links: [
          homeComponant,
          {
            text: '[FR] - page des produits',
            componant: {
              name: 'products',
            },
          },
        ],
      },
      providers: {
        links: [
          homeComponant,
          {
            text: '[FR] - page des producteurs',
            componant: {
              name: 'providers',
            },
          },
        ],
      },
    },
  },
  product: 'Produits',
  dispo: 'DISPO'
};
